import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatchEx, useSelectorEx } from '../../hooks/redux';
import Preloader from '../molecules/Preloader/Preloader';
import UsersList from '../molecules/UsersList/UsersList';
import {
    asyncDeleteTokenAction,
    asyncGetUsersAction,
    asyncUpdateUserAction,
    asyncCreateUserAction,
    asyncSetUserRoleAction,
} from '../../redux/slices/users/usersAction';
import { setCurrentPageUsers } from '../../redux/slices/users/usersSlice';

const UsersContainer: FC = () => {
    const { users, totalUsers, currentPage, limit, isLoading } = useSelectorEx(
        (state) => state.users,
    );
    const { pageNumber } = useParams();
    const dispatch = useDispatchEx();

    useEffect(() => {
        const newPageNumber = pageNumber ? Number(pageNumber) : 1;

        dispatch(
            asyncGetUsersAction({
                page: newPageNumber,
                limit,
            }),
        );
        dispatch(setCurrentPageUsers(newPageNumber));
    }, [pageNumber, dispatch, limit]);

    const onPagination = (page: number) => {
        dispatch(
            asyncGetUsersAction({
                page,
                limit,
            }),
        );
        dispatch(setCurrentPageUsers(page));
    };

    const onUpdateUser = (
        id: number,
        data: { login: string; password?: string },
    ): Promise<void> => {
        return dispatch(asyncUpdateUserAction({ id, ...data }))
            .unwrap()
            .then(() => {});
    };

    const onDeleteToken = (userId: number, tokenId: number): Promise<void> => {
        return dispatch(asyncDeleteTokenAction({ userId, tokenId }))
            .unwrap()
            .then(() => {});
    };

    const onCreateUser = (
        login: string,
        password: string,
        role: string,
    ): Promise<void> => {
        return dispatch(asyncCreateUserAction({ login, password, role }))
            .unwrap()
            .then(() => {});
    };

    const onChangeRole = (userId: number, role: string): Promise<void> => {
        return dispatch(asyncSetUserRoleAction({ userId, title: role }))
            .unwrap()
            .then(() => {});
    };

    if (isLoading) return <Preloader />;

    return (
        <UsersList
            items={users}
            totalCount={totalUsers}
            currentPage={currentPage}
            pageUrl="/admin/users"
            onChangePagination={onPagination}
            onUpdateUser={onUpdateUser}
            onDeleteToken={onDeleteToken}
            onCreateUser={onCreateUser}
            onChangeRole={onChangeRole}
        />
    );
};

export default UsersContainer;
